import { Box } from '@mui/material';
import { useEffect } from 'react';

const executeScript = (scriptContent: string) => {
    try {
        const func = new Function(scriptContent);
        func();
    } catch (error) {
        console.error('Error executing script:', error);
    }
};

export default function HtmlPart({ htmlContent }: { htmlContent: string }) {
    useEffect(() => {
        const scriptMatches = htmlContent.match(/<script[^>]*>(.*?)<\/script>/gs);
        if (scriptMatches) {
            scriptMatches.forEach((script) => {
                const match = script.match(/<script[^>]*>(.*?)<\/script>/s);
                if (match && match[1]) {
                    executeScript(match[1]);
                }
            });
        }
    }, [htmlContent]);

    return <Box dangerouslySetInnerHTML={{ __html: htmlContent }} />;
}
